import { render, staticRenderFns } from "./AddUpgradeProductModal.vue?vue&type=template&id=606f11c6&"
import script from "./AddUpgradeProductModal.vue?vue&type=script&lang=js&"
export * from "./AddUpgradeProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports